import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {CodeNameTranslate} from "app/shared/models/code-name-translate";
import {Formatters} from "../../../slick-grid/models/formatters";
import {BufferGraphService} from "../../services/buffer-graph.service";
import {SlickGridComponent} from "../../../slick-grid/slick-grid.component";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import * as Popper from 'popper.js/dist/umd/popper';
import {CodeNameChartTabs} from "../../models/code-name-chart-tabs";
import {CommonService} from "../../../services/common.service";
import {TabItem} from "../../models/tab-item";

@Component({
    selector: 'tabs-list',
    templateUrl: './tabs-list.component.html',
    styleUrls: ['./tabs-list.component.css']
})
export class TabsListComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                private dataExchange: BufferGraphDataExchangeService,
                private graphService: BufferGraphService){

        this.selectionModel = new Slick.RowSelectionModel<TabItem, Slick.Range[]>({selectActiveRow: false});
        this.gridView = new Slick.Data.DataView<TabItem>();

        this.columns = [
            {
                id: 'selected',
                field: 'selected',
                name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
                sortable: false,
                width: 20,
                formatter: (r, c, v) => Formatters.checkBoxFormatter(r, c, v)
            },
            {id: 'name', field: 'name', name: 'Name', sortable: true, width: 220}
        ];

        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
        };

        this.helper = new ChartHelper();
        this.hide = new EventEmitter<boolean>();
        this.loadingOutput = new EventEmitter<boolean>();
        // this.dataOutput = new EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.selected = [];
        this.timeOut = null;
        this.checkBoxHeader = null;
    };

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown  && this.checkDimensionsChange()){
            this.mouseDown = false;
            this.resizeGrid(true)
        }
    }

    private checkDimensionsChange = (): boolean => {
        let height = this.mainWrapper.nativeElement.offsetHeight,
            width = this.mainWrapper.nativeElement.offsetWidth,
            changed = this.height !== height || this.width !== width;
        if (changed){
            this.height = height;
            this.width = width;
        }
        return changed;

    }

    @Input() private GUID: string;
    @Input() private addRef: ElementRef;
    @Input() private wrpRef: ElementRef | HTMLElement;

    @Output()
    private readonly hide: EventEmitter<boolean>;

    @Output()
    private readonly loadingOutput: EventEmitter<boolean>;

    // @Output()
    // private readonly dataOutput: EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>;
    //
    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    private readonly gridView: Slick.Data.DataView<TabItem>;
    private readonly columns: Slick.Column<TabItem>[];
    private readonly options: Slick.GridOptions<TabItem>;
    private readonly selectionModel: Slick.RowSelectionModel<TabItem, Slick.Range[]>;
    private cellCssStyles: { [key: string]: Slick.CellCssStylesHash };
    private data: CodeNameChartTabs;
    public _loading: boolean;
    private helper: ChartHelper;
    private subscriptionMouseMove: ISubscription;
    private popperAddVar: Popper;
    private listenMouseDown: () => void;
    // private data: CompareItem[];
    private selected: TabItem[];
    private filteredData: TabItem[];
    private searchData: string;
    private mouseDown: boolean;
    private timeOut: any;
    private showActivity: boolean;
    public outline: boolean;
    private checkBoxHeader: any;
    private height: number;
    private width: number;
    private styles: {[key: string]: string};

    // private listenContextMenu: () => void;


    async ngOnInit(){

        // this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideList(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(e =>
            this.helper.tryCatch(() => e && this.mouseDown && this.resizeGrid())
        );
        const data = this.dataExchange.getTabsList(this.GUID);

        //console.log(data, 'ngOnInit');

        // const data = allTabsData ? allTabsData.filter(item => item.GUID === this.GUID).find(item => !!item): null;

        let height = this.wrpRef && (this.wrpRef as ElementRef).nativeElement ?  (this.wrpRef as ElementRef).nativeElement.offsetHeight : (this.wrpRef as HTMLElement).offsetHeight;
        if (300 > height){
            this.styles = { "max-height": height + 'px' };
        }

        if (data){
            this.data = data.clone();
            this.filteredData = this.data.tabs;
            this.gridView.setItems(this.filteredData);
        } else{
            await this.loadData();
        }
        if (data){
            this.resizeGrid(true);
            this.helper.wait(() => this.setSelectedRows());
        }
    }

    ngOnDestroy(){
        this.listenMouseDown();
    }

    async ngAfterViewInit(){
        //this.helper.wait(() => this.setCellStyles());
        this.popperAdd();
    }

    //# load list of tabs
    private loadData = async (): Promise<void> =>{
        this.loading = true;
        let list: CodeNameChartTabs = await this.helper.getDefaultTabsList(this.GUID, this.translateService, this.graphService, this.commonData);
        if (!list){
            this.loading = false;
            return;
        }
        this.dataExchange.setTabsList(list);
        this.data = list.clone();
        this.filteredData = this.data.tabs;
        this.loading = false;
        this.gridView.setItems(this.filteredData);
    }

    //# toggle tab selection
    public onGridClick = (args: any): void =>{
        let data = this.gridView.getItemByIdx(args.data.row),
            el = args.event.target,
            row = args.data.row;

        if (el.tagName.toLowerCase() === 'input'){
            return;
        }

        this.selectRow(data);
        this.grid.updateRow(row);

        data.selected ? this.data.selected.push(data) : this.helper.remFromArr(this.data.selected, 'id', data.id)
    };

    //# toggle select for row in grid
    public selectRow = (row: CodeNameTranslate, node?: HTMLElement): void =>{
        row.selected = !row.selected;
        this.setSelectedRows();
    };

    //# set selected row in grid, set to selected row color
    private setSelectedRows = (): void =>{
        let selected = this.filteredData.filter(item => item.selected);

        let id = selected.map(item => this.gridView.getIdxById(item.id.toString()));
        if (this.grid){
            this.grid.setSelectedRows(id);
        }
        this.checkAllSelect();
    };

    //# if all tabs is selected we set "all select" checkbox checked, in otherwise set "all select" checkbox not checked.
    private checkAllSelect = (): void =>{
        let allSelected = this.filteredData.length ? this.filteredData.every(item => item.selected) : false;
        this.helper.wait(() => allSelected ? this.checkBoxHeader.checked = true : this.checkBoxHeader.checked = false);
    };

    public onGridDblClick = (args: any): void =>{

    };

    //# enable loading image in inform about it parent component
    set loading(val: boolean){
        if (val !== this._loading){
            this._loading = val;
            this.helper.wait(() => this.loadingOutput.emit(val));
        }
    }

    get loading(): boolean{
        return this._loading;
    }

    //# add listener to "select all" checkbox
    public slickGridHeaders = (args: any): void =>{
        if (args.data.column.id === 'selected'){
            this.checkBoxHeader = args.data.node.querySelector('input');
            this.renderer.listen(this.checkBoxHeader, 'change', e => this.selectAll(e.target.checked));
        }
    };

    //# toggle all select
    private selectAll = (select: boolean): void =>{
        this.filteredData.forEach(item =>{
            item.selected = select;
            if (select){
                let has: boolean = this.data.selected.some(inItem => item.code === inItem.code);
                !has ? this.data.selected.push(item) : null;
            } /*else{
                this.data.selected.forEach(inItem => item.code === inItem.code ? has = true : null);
                has ? this.helper.remFromArr(this.data.selected, 'code', item.code) : null;
            }*/
        });

        !select ? this.data.selected.length = 0 : null;

        // this.data.selected.length = 0;
        this.gridView.setItems([]);
        this.gridView.setItems(this.filteredData);
        this.setSelectedRows();
    };

    //# add popper to this component
    public popperAdd = (): void =>{

        this.popperAddVar = new Popper(this.addRef && this.addRef.nativeElement ? this.addRef.nativeElement : this.addRef, this.mainWrapper.nativeElement.parentElement, {
            placement: 'bottom-start',
            modifiers: {
                flip: {
                    behavior: ['bottom', 'bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.wrpRef,
                    padding: 0
                },
            },
        });

        this.helper.wait(() => this.popperAddVar.update(), 5)
    };

    //# hide list
    private hideList = (e: MouseEvent): void =>{
        this.mouseDown = true;
        this.height = this.mainWrapper.nativeElement.offsetHeight;
        this.width = this.mainWrapper.nativeElement.offsetWidth;
        let dialog =  $('#app-dialog')[0];

        if (this.helper.hideList(this.mainWrapper, e, this.renderer) && this.helper.hideList(dialog, e, this.renderer)){
            this.helper.wait(() => this.hide.emit(false), 500);
        }
    };

    //# search in list
    public filterSearch = (e?: KeyboardEvent, keyDown?: boolean): void =>{

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 18)) return;

        if (e && e.keyCode === 27 && !keyDown){
            return;
        }

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
            return;
        }

        let data: string[] = [];
        if (this.searchData && !keyDown){
            data = this.searchData.split(' ').map(item => item.trim());
        }

        if (this.data && this.data.tabs.length > 0 && !keyDown){

            if (this.searchData && this.searchData.length > 0){
                this.filteredData = this.data.tabs.filter(item =>{
                    item.findCode = this.helper.matchText(data, item.code);
                    item.findName = this.helper.matchText(data, item.name);
                    return item.findCode || item.findName;
                });
            } else{
                this.data.tabs.forEach(item =>{
                    item.findCode = false;
                    item.findName = false;
                });
                this.filteredData = this.data.tabs;
            }

            this.gridView.setItems([]);
            this.gridView.setItems(this.filteredData);

            this.columnWidth();
            this.setCellStyles();
        }
    };

    //# set color for grid sells
    private setCellStyles = (): void =>{
        let mainStyles = null;

        this.filteredData.forEach((row: CodeNameTranslate) => mainStyles = this.setCellMainStyles(mainStyles, row, this.gridView.getIdxById(String(row.id))));
        const styles = {};
        if (mainStyles === null) mainStyles = {};
        styles['main-styles'] = mainStyles;
        this.cellCssStyles = styles;

    };

    //# generate colors for grid sells on row
    private setCellMainStyles = (hash: Slick.CellCssStylesHash, row: CodeNameTranslate, index: number): Slick.CellCssStylesHash =>{
        let styles = null;

        if (row.findCode)
            styles = Object.assign({}, {code: 'found'});

        if (row.findName)
            styles = Object.assign(styles || {}, {name: 'found'});

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    //# ask question in which mode open tabs
    public showSelect = (): void =>{
        let first: string = 'OpenTabsInSingleMode',
            second: string = 'OpenTabsInViewMode';
        if (this.data.viewMode === null && this.data.selected.length > 1){
            this.translateService.get([first, second])
                .subscribe(s => {
                    try{
                        this.commonData.showRadioSelection(
                            [s[first], s[second]],
                            (idx: number) => {
                                try {
                                    this.apply('Apply', idx)
                                } catch (e){

                                }
                            }
                        )
                    } catch (e){

                    }

                });
            return;
        } else {
            let mode = this.data.viewMode === null ? 0 : this.data.viewMode;
            this.apply('Apply', mode)
        }
    };

    //# apply selection
    public apply = (command: string, mode: number = null): void =>{
        switch (command){
            case 'Apply':
                mode !== null ? this.data.viewMode = mode : null;
                console.log(this.data, 'apply tab list')
                this.dataExchange.setTabsList(this.data);
                break;
        }
        this.helper.wait(() => this.hide.emit(true), 10)

    };

    //# resize grid when dimensions of wrapper changing
    public resizeGrid = (last?: boolean): void =>{
        if (this.grid && this.mouseDown){
            if (this.timeOut){
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }

            this.timeOut = setTimeout(() =>{
                //this.columnWidth();
                this.grid.resizeGrid();
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }, 100);
        } else if (this.grid && last){
            this.helper.wait(() => this.columnWidth());
        }
        this.checkAllSelect();
    };

    //# recalculate grid column width when dimensions of wrapper changing
    private columnWidth = (): void =>{
        if (!this.gridWrpEl || !this.grid){
            return;
        }

        let slickScrollWidth = 8,
            width = this.gridWrpEl.nativeElement.offsetWidth - 2,
            gridHeight = this.gridWrpEl.nativeElement.offsetHeight;
        let stringQuantity = Math.floor((gridHeight - 5) / 25) - 1;
        if (this.filteredData.length > stringQuantity){
            width = width - slickScrollWidth;
        }
        this.columns.forEach(item =>{
            if (item.field !== 'name'){
                width = width - item.width;
            }
        });

        this.columns.forEach(item =>{
            if (item.field === 'name' && width > 100){
                item.width = width;
            }
        });

        this.grid.setColumns(this.columns);
        this.grid.resizeGrid();
    }
}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/tabs-list.component/tabs-list.component.ts